// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    db: "besselai-website",
    container: "resumes",
    jwt: "8AHXaFJiknwMD7U2kkNQ1PzI4ys88tyS3FGZulwMyub5ntSCr5CIzPqFj9qTG38K",
    backend: {
      // baseURL:"https://api.feedfront.ai/",
        baseURL:"https://api.besselai.com/",
      uploadURL: "https://besselai.com/",
      imagesURL: "https://ritehirefiles.blob.core.windows.net/", 
    },
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  